export default "__VITE_ASSET__f854d2d5__"